export default "__VITE_ASSET__BuhKH66L__"